import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=78dda588&scoped=true&"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=78dda588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dda588",
  null
  
)

export default component.exports